// extracted by mini-css-extract-plugin
export default {"root":"A8ikWyMw","video":"ikYBhbUg"};